import React, { useEffect, useState } from "react";
import styled from "styled-components";

import {
  ControlDockHeader,
  ControlDockContent,
  PathButtonContainer,
} from "../styled/potree/PotreeControl.styles";
import PathSelectCard from "./PathSelectCard";
import { getPathList } from "../../api/ProjectAPI";
import { useParams } from "react-router-dom";
import { usePathModeStore } from "../../Store/PotreeStore";
import AutoPathSelectCard from "./AutoPathSelectCard";

const PathselectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .path_item_date {
    font-size: 12px;
    color: #a6a6a6;
  }
`;

export default function Pathselect() {
  const [pathList, setPathList] = useState([]);
  const [autoPathList, setAutoPathList] = useState([]);
  const [manualPathList, setManualPathList] = useState([]);

  const { projectId } = useParams();

  const { SelectionGenerateMode, setSelectionGenerateMode } =
    usePathModeStore();

  const fetchPathList = async () => {
    const response = await getPathList(projectId);

    const { autoPaths, manualPaths } = response.reduce(
      (acc, path) => {
        if (path.workType?.includes("AUTO")) {
          acc.autoPaths.push(path);
        } else {
          acc.manualPaths.push(path);
        }
        return acc;
      },
      { autoPaths: [], manualPaths: [] },
    );

    setAutoPathList(autoPaths);
    setManualPathList(manualPaths);
  };

  useEffect(() => {
    fetchPathList();
  }, []);

  const handleSelectionGenerateMode = (mode) => {
    setSelectionGenerateMode(mode);
  };
  return (
    <>
      <ControlDockHeader>
        <h2>경로 선택</h2>
        <p>공개된 경로를 선택할 수 있습니다.</p>
      </ControlDockHeader>
      <PathButtonContainer>
        <button
          onClick={() => handleSelectionGenerateMode("auto")}
          className={SelectionGenerateMode === "auto" ? "active" : ""}
        >
          자동 경로
        </button>
        <button
          onClick={() => handleSelectionGenerateMode("manual")}
          className={SelectionGenerateMode === "manual" ? "active" : ""}
        >
          수동 경로
        </button>
      </PathButtonContainer>
      <ControlDockContent>
        {SelectionGenerateMode === "auto" ? (
          <PathselectContainer>
            {autoPathList.map((path) => (
              <AutoPathSelectCard
                key={path.id}
                path={path}
                fetchPathList={fetchPathList}
              />
            ))}
          </PathselectContainer>
        ) : (
          <PathselectContainer>
            {manualPathList.map((path) => (
              <PathSelectCard
                key={path.id}
                path={path}
                fetchPathList={fetchPathList}
              />
            ))}
          </PathselectContainer>
        )}
      </ControlDockContent>
    </>
  );
}
